// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SignalAssetTypeSchema = z.enum(['DOMAIN','HOST','NETWORK_SERVICE','SOFTWARE','STORAGE_SERVICE'] as const);

export type SignalAssetTypeType = `${z.infer<typeof SignalAssetTypeSchema>}`

export default SignalAssetTypeSchema;
